import { render, staticRenderFns } from "./SinisterView.vue?vue&type=template&id=1255fba1"
import script from "./SinisterView.vue?vue&type=script&lang=js"
export * from "./SinisterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/SinisterView.vue
// module id = 2099
// module chunks = 31